import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] px-4">
      <div className="card p-8 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={52} className="text-amber mx-auto mb-4" />
        <h1 className="font-heading text-xl font-bold">Pembayaran Dibatalkan</h1>
        <p className="text-sm text-[var(--text-secondary)] mt-2 mb-6">Anda membatalkan proses pembayaran. Tidak ada dana yang terpotong.</p>
        <button onClick={() => navigate("/dashboard")} data-testid="cancel-back-btn" className="w-full h-11 rounded-lg bg-[var(--accent)] text-[#07090E] font-semibold hover:bg-[var(--accent-hover)]">Kembali ke Dashboard</button>
      </div>
    </div>
  );
}
